import { CircleSparkIcon } from '@synoptic/ui-kit/icons/react/circle-spark.js';
import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.js';
import { clsx } from 'clsx';
import {
  postSummaryContainer,
  postSummaryContainerCompact,
  postSummaryHeader,
  postSummaryHeaderCompact,
  postSummarySkeletons,
  postSummaryText,
} from './summarize.css.ts';

export const PostSummary = ({
  summary,
  loading,
  compact,
}: {
  summary: string | undefined;
  loading: boolean;
  compact?: boolean;
}) => {
  const iconSize = compact ? 12 : 14;

  return (
    <div
      className={clsx(
        postSummaryContainer,
        compact && postSummaryContainerCompact,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={clsx(postSummaryHeader, compact && postSummaryHeaderCompact)}
      >
        <CircleSparkIcon width={iconSize} height={iconSize} />
        Summary
      </div>
      {loading || !summary ? (
        <div className={postSummarySkeletons}>
          <Skeleton width="100%" height={10} />
          <Skeleton width="100%" height={10} />
          <Skeleton width="60%" height={10} />
        </div>
      ) : (
        <p className={postSummaryText}>{summary}</p>
      )}
    </div>
  );
};
